import {
    REFERRAL_LINKS_FETCH,
    REFERRAL_LINKS_IS_FETCING,
    REFERRAL_LINK_FILTER,
    REFERRAL_LINK_EDIT,
} from 'constants/referralLinks'

export default function referralLinksReducer(state = {
    list: [],
    pageable: {
        sort: {
            'referralLinkId': 'asc',
        },
        filter: {},
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
        case REFERRAL_LINKS_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case REFERRAL_LINK_EDIT:
            return {
                ...state,
                // list: state.list.find(e=>state.referralLinkId===e.referralLinkId)?,
            }
        case REFERRAL_LINKS_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
            }
        case REFERRAL_LINK_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/referralLinks.js